<section
  class="jumbotron hero-background text-white text-center pt-0 pb-0 justify-content-center d-flex"
  [class.padding-top]="iconClass == null && preHeader == null"
  [class.has-button]="buttonText != null || videoUrl != null"
  [ngStyle]="{ 'background-image': 'url(https://company.rubbl.com' + imagePath + ')' }"
>
  <div class="align-self-center">
    <i class="icon-super-large" *ngIf="iconClass" [ngClass]="iconClass"></i>
    <p class="fs-22 preHeader" *ngIf="preHeader">{{ preHeader }}</p>
    <h2 class="jumbotron-header" [class.landing-page]="!isTopOfPage" [class.header-with-preHeader]="preHeader">{{ header }}</h2>
    <p class="subhead-2 small-container mb-4" [class.mt-4]="preHeader">
      {{ subHeader }}
    </p>
    <div class="lead mt-5" *ngIf="buttonText">
      <button class="btn btn-primary btn-lg" (click)="click()" role="button">
        {{ buttonText }}
      </button>
    </div>
    <div class="mt-4">
      <i *ngIf="videoUrl" (click)="watchVideo()" class="icon-play-button rounded-circle"></i>
    </div>
  </div>
</section>
